import React, { useEffect } from "react";
import "./home.css";
import { makeid } from "../shared/utils";
import { useHistory, Link } from "react-router-dom";
import { db, signUserIn } from "../firebase";

import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { Button, Grid, Tabs, Tab, Box } from "@material-ui/core";
import BrushIcon from "@material-ui/icons/Brush";

import screenshot7 from "../assets/scr7.webp";
import categories from "../assets/categories.webp";
import manchor from "../assets/manchor.svg";
import meeting from "../assets/meeting.webp";
import brainstorm from "../assets/brainstorm.webp";
import retro from "../assets/retro.webp";
import linearLogo from "../assets/logo_linear.png";

import categoriesFallback from "../assets/categories.png";
import meetingFallback from "../assets/Archive/meeting.png";
import screenshot7Fallback from "../assets/Archive/scr7.png";
import brainstormFallback from "../assets/Archive/brainstorm.png";
import retroFallback from "../assets/Archive/retro.png";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  },
  tab: {
    fontSize: "4vw",
    [theme.breakpoints.up("sm")]: {
      fontSize: 18,
    },
    fontWeight: 400,
    textTransform: "none",
  },
  tabSelected: {
    fontWeight: 700,
  },
}));

function Home() {
  const history = useHistory();

  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [loopNumber, setLoopNumber] = React.useState(9);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  useEffect(() => {
    signUserIn();
    let myLoopNo = 9;
    const interval = setInterval(() => {
      if (myLoopNo === 0) {
        myLoopNo = 9;
      } else myLoopNo -= 1;
      setLoopNumber(myLoopNo);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  function handleClick() {
    const publicUrl = makeid(10);
    const adminExtension = makeid(10);
    db.ref(`/userdata/${publicUrl}`).set({
      adminUrlExtension: adminExtension,
      creationTime: Date.now(),
    });
    history.push(`/b/${publicUrl}/${adminExtension}`);
  }

  return (
    <div className="Home">
      <div className="Test">
        <div className="Gradient"></div>
        <div className="Wave-container">
          <div className="Wave"></div>
          <div className="Wave"></div>
          {/* <div class="wave"></div> */}
        </div>
      </div>
      <div className="Home-header">
        {/* <svg
          className="Home-top-wave"
          viewBox="0 0 1440 77"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0 15.4L21.6 14.1167C43.2 12.8333 87.6 10.2667 130.8 15.4C174 20.5333 218.4 33.3667 261.6 32.0833C306 30.8 349.2 15.4 392.4 16.6833C436.8 17.9667 480 35.9333 523.2 39.7833C567.6 43.6333 610.8 33.3667 654 30.8C698.4 28.2333 741.6 33.3667 786 38.5C829.2 43.6333 872.4 48.7667 916.8 43.6333C960 38.5 1003.2 23.1 1047.6 16.6833C1090.8 10.2667 1134 12.8333 1178.4 21.8167C1221.6 30.8 1266 46.2 1309.2 56.4667C1352.4 66.7333 1396.8 71.8667 1418.4 74.4333L1440 77V0H1418.4C1396.8 0 1352.4 0 1309.2 0C1266 0 1221.6 0 1178.4 0C1134 0 1090.8 0 1047.6 0C1003.2 0 960 0 916.8 0C872.4 0 829.2 0 786 0C741.6 0 698.4 0 654 0C610.8 0 567.6 0 523.2 0C480 0 436.8 0 392.4 0C349.2 0 306 0 261.6 0C218.4 0 174 0 130.8 0C87.6 0 43.2 0 21.6 0H0V15.4Z"
            fill="#022855"
          />
        </svg>

        <svg
          className="Home-top-wave-small"
          viewBox="0 0 394 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M263 30.8001C306.2 33.3668 349.4 43.6335 393.8 39.7835L393.8 0.000137329L263 0.000125894L131 0.000114354L0.199772 0.000102919L0.199768 43.6334C44.5998 48.7668 87.7997 43.6334 131 38.5001L133.316 38.2322C176.903 33.1905 219.372 28.2781 263 30.8001Z"
            fill="#022855"
          />
        </svg> */}
        <div className="Home-header-container">
          <div className="Home-logo-container">
            <Link to="/">
              <img
                src={linearLogo}
                className="Home-logo"
                alt="Moored logo"
                width="150px"
              />
            </Link>
            {/* <div className="Home-lines"></div>
            <div className="Home-lines" style={{marginTop: '40px', width: '500px'}}></div>
            <div className="Home-lines" style={{marginTop: '60px', width: '60px', backgroundColor: "gray"}}></div> */}
          </div>
          <Grid container spacing={0}>
            <Grid item className="Home-header-left" xs={12} sm={7} md={5}>
              <div className="Home-header-left-content">
                <h1>Collect feedback from your team</h1>
                <div className="Home-header-left-content-body">
                  <p>
                    Moored is a lightweight tool for team meetings, brainstorms,
                    and retrospectives that allows you to anonymously collect
                    questions and comments
                  </p>
                </div>
                <Button
                  onClick={handleClick}
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Create a board
                </Button>
                <p style={{ fontSize: "14px", color: "#666" }}>
                  Free & no account required
                </p>
              </div>
            </Grid>
            <Grid item className="Home-header-right" xs={12} sm={5} md={7}>
              <picture className="Home-header-screenshot-container">
                <source
                  className="Home-header-screenshot"
                  srcset={screenshot7}
                  type="image/webp"
                />
                <img
                  className="Home-header-screenshot"
                  src={screenshot7Fallback}
                  alt={"logo"}
                />
              </picture>
            </Grid>
          </Grid>
        </div>
      </div>
      <div className="Home-use-cases">
        <span className="Home-section-title">Use cases</span>
        <Tabs
          className="Home-use-cases-tabs"
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          // aria-label="full width tabs example"
        >
          <Tab
            label="Team meetings"
            {...a11yProps(0)}
            disableRipple="true"
            classes={{
              root: classes.tab,
              selected: classes.tabSelected,
            }}
          />
          <Tab
            label="Brainstorms"
            {...a11yProps(1)}
            disableRipple="true"
            classes={{
              root: classes.tab,
              selected: classes.tabSelected,
            }}
          />
          <Tab
            label="Retros"
            {...a11yProps(2)}
            disableRipple="true"
            classes={{
              root: classes.tab,
              selected: classes.tabSelected,
            }}
          />
        </Tabs>
        <SwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={value}
          onChangeIndex={handleChangeIndex}
        >
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Grid container spacing={0}>
              <Grid
                item
                className="Home-use-cases-tab-content-left"
                xs={12}
                sm={6}
              >
                <picture>
                  <source width="100%" srcset={meeting} type="image/webp" />
                  <img width="100%" src={meetingFallback} alt="meeting" />
                </picture>
              </Grid>
              <Grid
                item
                className="Home-use-cases-tab-content-right"
                xs={12}
                sm={6}
              >
                Gather questions and thoughts ahead of time to make sure team
                members are prepared and meeting time is used effectively.
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <Grid container spacing={0}>
              <Grid
                item
                className="Home-use-cases-tab-content-left"
                xs={12}
                sm={6}
              >
                <picture>
                  <source width="100%" srcset={brainstorm} type="image/webp" />
                  <img width="100%" src={brainstormFallback} alt="brainstorm" />
                </picture>
              </Grid>
              <Grid
                item
                className="Home-use-cases-tab-content-right"
                xs={12}
                sm={6}
              >
                Use Moored during collaborative brainstorms to allow your team
                members to share their ideas and see each other's thoughts in
                real-time.
              </Grid>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2} dir={theme.direction}>
            <Grid container spacing={0}>
              <Grid
                item
                className="Home-use-cases-tab-content-left"
                xs={12}
                sm={6}
              >
                <picture>
                  <source width="100%" srcset={retro} type="image/webp" />
                  <img width="100%" src={retroFallback} alt="retro" />
                </picture>
              </Grid>
              <Grid
                item
                className="Home-use-cases-tab-content-right"
                xs={12}
                sm={6}
              >
                Ensure your team learns from their mistakes and their successes
                by collecting anonymous feedback.
              </Grid>
            </Grid>
          </TabPanel>
        </SwipeableViews>
      </div>

      <svg
        className="Svg-element"
        viewBox="0 0 1440 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1440 55.2203V56H0V55.2203C212.536 20.069 458.234 0 720 0C981.766 0 1227.46 20.069 1440 55.2203Z"
          fill="#054188"
        />
      </svg>

      <div className="Home-features">
        <div className="Home-how">
          <span
            className="Home-section-title-light"
            style={{ marginBottom: "40" }}
          >
            Features
          </span>
          <Grid container spacing={0}>
            <Grid className="Home-features-section-pieces" item xs={12} sm={4}>
              <div className="Home-features-image">
                <div>
                  <span class="blinking-cursor">|</span>
                  <span className="Home-features-board-title">Board title</span>
                </div>
              </div>
              <h2>Start right away</h2>
              <p>No sign ups or subscriptions</p>
            </Grid>
            <Grid className="Home-features-section-pieces" item xs={12} sm={4}>
              <div className="Home-features-image">
                <picture>
                  <source
                    style={{ width: "100%" }}
                    srcset={categories}
                    type="image/webp"
                  />
                  <img
                    style={{ width: "100%" }}
                    src={categoriesFallback}
                    alt="logo"
                  />
                </picture>
              </div>
              <h2>Get organized</h2>
              <p>Collect comments and arrange them by category</p>
            </Grid>
            <Grid className="Home-features-section-pieces" item xs={12} sm={4}>
              <div className="Home-features-image">
                <span className="Home-timer-numbers">2:5{loopNumber}</span>
              </div>
              <h2>Stay on time</h2>
              <p>Set a countdown timer for live collaboration</p>
            </Grid>
          </Grid>
        </div>
        <svg
          style={{ marginTop: "80px" }}
          className="Svg-element"
          viewBox="0 0 1440 56"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="rotate(0 0 90)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1440 55.2203V56H0V55.2203C212.536 20.069 458.234 0 720 0C981.766 0 1227.46 20.069 1440 55.2203Z"
              fill="#dfeeff"
            />
          </g>
        </svg>
      </div>

      <div className="Home-bottom-container">
        <div className="Home-how">
          <span className="Home-section-title">How it works</span>
          <Grid container className="Home-how-section" spacing={0}>
            <Grid className="Home-how-section-steps" item xs={12} sm={4}>
              <span className="Home-how-section-numbers">1</span>
              <p>Create a board with instructions for your team</p>
            </Grid>
            <Grid className="Home-how-section-steps" item xs={12} sm={4}>
              <span className="Home-how-section-numbers">2</span>
              <p>
                Share the board with everyone you want to collect input from
              </p>
            </Grid>
            <Grid className="Home-how-section-steps" item xs={12} sm={4}>
              <span className="Home-how-section-numbers">3</span>
              <p>
                View responses as they are submitted and organize them by
                category
              </p>
            </Grid>
          </Grid>
          <Button
            onClick={handleClick}
            variant="contained"
            color="primary"
            size="large"
            style={{ marginBottom: "30px", marginTop: "10px" }}
          >
            Create a board
          </Button>
        </div>
      </div>

      <div className="Home-animation-container">
        <img className="Home-animated-logo" src={manchor} alt="Moored anchor" />
        <img
          className="Home-animated-logo"
          src={manchor}
          alt="Moored anchor"
          style={{ animationDelay: "1s" }}
        />
        <img
          className="Home-animated-logo"
          src={manchor}
          alt="Moored anchor"
          style={{ animationDelay: "2s" }}
        />
        <img
          className="Home-animated-logo"
          src={manchor}
          alt="Moored anchor"
          style={{ animationDelay: "3s" }}
        />
        <img
          className="Home-animated-logo"
          src={manchor}
          alt="Moored anchor"
          style={{ animationDelay: "4s" }}
        />
        {/* <svg className="Home-animated-logo" width="100"  viewBox="0 0 211 212" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.1">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M105.532 8.00134C100.24 15.1453 87.0286 27.7342 70.6058 29.4331C53.068 31.2474 30.4616 39.5122 16.8286 57.0359C-5.83539 81.1493 8.2235 114.823 20.0988 143.266C22.6001 149.257 25.0046 155.016 26.9486 160.405C29.029 160.405 31.0465 160.572 32.8837 160.724C39.5087 161.272 43.7906 161.627 40.2308 153.261C38.924 150.19 37.4912 146.983 36.0135 143.675C24.7837 118.536 10.9637 87.5996 30.1522 66.626C36.8641 59.2899 45.9953 55.6218 57.5458 55.6218C69.5647 55.6218 79.1642 59.602 86.3443 67.5626C93.5243 75.5231 97.1144 87.0737 97.1144 102.214V137.929C95.7658 149.999 92.0058 156.063 88.5393 161.654C84.9737 167.405 81.7187 172.654 81.7187 183.424C81.7187 196.576 92.3802 207.237 105.532 207.237C118.683 207.237 129.345 196.576 129.345 183.424C129.345 173.03 126.327 168.685 122.927 163.788C119.207 158.433 115.029 152.417 113.839 137.103V102.214C113.839 87.0737 117.429 75.5231 124.609 67.5626C131.789 59.602 141.389 55.6218 153.407 55.6218C164.958 55.6218 174.089 59.2899 180.801 66.626C199.99 87.5996 186.17 118.536 174.94 143.675C173.732 146.378 172.555 149.014 171.451 151.563C167.26 161.247 170.627 161.052 178.07 160.622C179.835 160.52 181.828 160.405 184.005 160.405C185.949 155.016 188.353 149.257 190.854 143.266C202.961 114.268 217.338 79.8331 192.756 55.6354C178.47 39.0702 155.756 31.1983 140.457 29.4331C124.056 27.5406 110.823 15.1453 105.532 8.00134ZM119.063 183.424C119.063 190.877 113.021 196.918 105.569 196.918C98.116 196.918 92.0745 190.877 92.0745 183.424C92.0745 175.972 98.116 169.93 105.569 169.93C113.021 169.93 119.063 175.972 119.063 183.424Z" fill="#0075B7"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M105.532 0L109.359 5.1665C114.266 11.792 126.455 23.0233 141.003 24.7019C157.003 26.548 180.915 34.7207 196.235 52.3783C209.783 65.8062 212.444 82.0857 210.284 98.28C208.166 114.164 201.345 130.503 195.378 144.792L195.249 145.101C192.737 151.118 190.381 156.764 188.485 162.021L187.35 165.168H184.005C181.984 165.168 180.119 165.274 178.345 165.377L178.162 165.387C176.45 165.487 174.612 165.593 173.04 165.505C171.571 165.423 169.145 165.142 167.236 163.447C164.972 161.437 164.691 158.688 164.941 156.567C165.182 154.52 165.987 152.198 167.081 149.671C168.196 147.095 169.383 144.437 170.587 141.743L170.591 141.732C176.26 129.042 182.254 115.563 184.592 102.735C186.904 90.0485 185.5 78.8178 177.287 69.8409C171.626 63.6531 163.858 60.3844 153.407 60.3844C142.555 60.3844 134.308 63.9204 128.146 70.7524C122.028 77.535 118.602 87.768 118.602 102.214V136.916C119.173 144.082 120.419 148.868 121.847 152.39C123.288 155.942 124.987 158.407 126.838 161.072L126.933 161.208C128.584 163.585 130.459 166.284 131.843 169.801C133.278 173.448 134.107 177.741 134.107 183.424C134.107 199.206 121.314 212 105.532 212C89.7499 212 76.9561 199.206 76.9561 183.424C76.9561 177.524 77.8539 172.95 79.3295 168.993C80.755 165.17 82.6726 162.078 84.4086 159.278L84.5196 159.099C87.8085 153.795 91.0997 148.487 92.3518 137.659V102.214C92.3518 87.768 88.9253 77.535 82.8077 70.7524C76.6455 63.9204 68.3978 60.3844 57.5458 60.3844C47.0949 60.3844 39.3273 63.6531 33.6661 69.8409C25.4532 78.8178 24.0492 90.0485 26.3614 102.735C28.6996 115.563 34.693 129.042 40.362 141.732L40.3716 141.754C41.8422 145.046 43.2896 148.286 44.6131 151.396C45.5774 153.662 46.287 155.932 46.2788 158.052C46.2693 160.538 45.2357 162.947 42.8605 164.399C40.9854 165.545 38.8398 165.705 37.4032 165.728C35.8877 165.752 34.1781 165.61 32.6321 165.482L32.4909 165.47C30.6293 165.316 28.8024 165.168 26.9486 165.168H23.6036L22.4685 162.021C20.572 156.764 18.2161 151.118 15.7039 145.101L15.581 144.807C9.7263 130.784 3.05049 114.795 0.797834 99.2085C-1.49175 83.3664 0.70566 67.3466 13.2059 53.9369C27.9107 35.1723 51.8419 26.5862 70.1158 24.6958C84.6132 23.196 96.7643 11.836 101.705 5.1665L105.532 0ZM16.8286 57.0359C-5.83539 81.1493 8.2235 114.823 20.0988 143.266C22.6001 149.257 25.0046 155.016 26.9486 160.405C29.029 160.405 31.0465 160.572 32.8837 160.724C39.5087 161.272 43.7906 161.627 40.2308 153.261C38.924 150.19 37.4912 146.983 36.0135 143.675C24.7837 118.536 10.9637 87.5996 30.1522 66.626C36.8641 59.2899 45.9953 55.6218 57.5458 55.6218C69.5647 55.6218 79.1642 59.602 86.3443 67.5626C93.5243 75.5231 97.1144 87.0737 97.1144 102.214V137.929C95.7658 149.999 92.0058 156.063 88.5393 161.654C84.9737 167.405 81.7187 172.654 81.7187 183.424C81.7187 196.576 92.3802 207.237 105.532 207.237C118.683 207.237 129.345 196.576 129.345 183.424C129.345 173.03 126.327 168.685 122.927 163.788C119.207 158.433 115.029 152.417 113.839 137.103V102.214C113.839 87.0737 117.429 75.5231 124.609 67.5626C131.789 59.602 141.389 55.6218 153.407 55.6218C164.958 55.6218 174.089 59.2899 180.801 66.626C199.99 87.5996 186.17 118.536 174.94 143.675C173.732 146.378 172.555 149.014 171.451 151.563C167.26 161.247 170.627 161.052 178.07 160.622C179.835 160.52 181.828 160.405 184.005 160.405C185.949 155.016 188.353 149.257 190.854 143.266C202.961 114.268 217.338 79.8331 192.756 55.6354C178.47 39.0702 155.756 31.1983 140.457 29.4331C126.675 27.8428 115.13 18.8359 108.654 11.761C107.424 10.4166 106.377 9.14203 105.532 8.00134C104.688 9.14052 103.643 10.4182 102.415 11.768C95.9448 18.8833 84.4098 28.0051 70.6058 29.4331C53.068 31.2474 30.4616 39.5122 16.8286 57.0359ZM105.569 192.156C110.391 192.156 114.3 188.247 114.3 183.424C114.3 178.602 110.391 174.693 105.569 174.693C100.746 174.693 96.8372 178.602 96.8372 183.424C96.8372 188.247 100.746 192.156 105.569 192.156ZM105.569 196.918C113.021 196.918 119.063 190.877 119.063 183.424C119.063 175.972 113.021 169.93 105.569 169.93C98.116 169.93 92.0745 175.972 92.0745 183.424C92.0745 190.877 98.116 196.918 105.569 196.918Z" fill="#0075B7"/>
        <path d="M46.8297 185.806L4.75998 152.581C4.75998 152.581 17.9365 157.406 32.3831 151.762C46.8297 146.117 49.5205 133.417 49.5205 133.417L46.8297 185.806Z" fill="#0075B7"/>
        <path d="M164.617 185.806L206.687 152.581C206.687 152.581 193.51 157.406 179.064 151.762C164.617 146.117 161.926 133.417 161.926 133.417L164.617 185.806Z" fill="#0075B7"/>
        </g>
      </svg> */}
      </div>
      <svg
        className="Svg-element"
        viewBox="0 0 1440 77"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 61.6L21.6 62.8833C43.2 64.1667 87.6 66.7333 130.8 61.6C174 56.4667 218.4 43.6333 261.6 44.9167C306 46.2 349.2 61.6 392.4 60.3167C436.8 59.0333 480 41.0667 523.2 37.2167C567.6 33.3667 610.8 43.6333 654 46.2C698.4 48.7667 741.6 43.6333 786 38.5C829.2 33.3667 872.4 28.2333 916.8 33.3667C960 38.5 1003.2 53.9 1047.6 60.3167C1090.8 66.7333 1134 64.1667 1178.4 55.1833C1221.6 46.2 1266 30.8 1309.2 20.5333C1352.4 10.2667 1396.8 5.13333 1418.4 2.56667L1440 0V77H1418.4C1396.8 77 1352.4 77 1309.2 77C1266 77 1221.6 77 1178.4 77C1134 77 1090.8 77 1047.6 77C1003.2 77 960 77 916.8 77C872.4 77 829.2 77 786 77C741.6 77 698.4 77 654 77C610.8 77 567.6 77 523.2 77C480 77 436.8 77 392.4 77C349.2 77 306 77 261.6 77C218.4 77 174 77 130.8 77C87.6 77 43.2 77 21.6 77H0V61.6Z"
          fill="#022855"
        />
      </svg>
      <div className="Footer">
        <div className="Footer-content">
          <Grid container spacing={0}>
            <Grid className="Footer-content-sections" item xs={12} sm={6}>
              <h2 className="Footer-content-header">About Moored</h2>
              <p>
                We built Moored to help remote teams have more collaborative
                meetings. Stay tuned for new meeting tools and features.
              </p>

              <p style={{ marginTop: "20px", fontSize: "14px" }}>
                <BrushIcon style={{ height: "14px" }} />
                Illustrations by Senem Çilingiroğlu
              </p>
            </Grid>
            <Grid className="Footer-content-sections" item xs={12} sm={6}>
              <h2 className="Footer-content-header">Contact us</h2>
              <p>
                Questions or comments? Please reach out to us at
                contact@moored.co
              </p>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}

export default Home;
